<template>
  <div class="trial-bar">
    <span v-if="dueDate"> Conta em Teste até {{ $formatDate(dueDate) }} </span>
    <span v-else> Conta em Teste </span>
  </div>
</template>

<script>
export default {
  name: 'AppTrialBar',
  props: {
    dueDate: Date,
  },
};
</script>

<style scoped>
.trial-bar {
  position: fixed;
  text-align: center;
  font-weight: 700;
  font-size: 1em;
  width: 100%;
  height: 20px;
  background-color: #83ff57;
  z-index: 999;
  bottom: 0;
}
</style>
